import gql from 'graphql-tag'

import MultipleLinkFieldContent from '@Queries/cms/fragments/MultipleLinkField.fragment'

export default gql`
    ${MultipleLinkFieldContent}
  fragment FieldContent on IField {
    __typename
    key
    ... on LinkField {
      key
      url
      newTab
      references {
        __typename
        ... on Page {
          id
          type
        }
      }
    }
    ... on JSONField {
      value
    }
    ... on MultipleLinkField {
        ... MultipleLinkFieldContent
    }
  }

  fragment NestableFieldContent on IField {
    ...FieldContent
    ... on ReferenceField {
      references {
        ...ReferenceContent
        ... on TileResource {
          elements {
            ...ElementsContent
          }
        }
      }
    }
  }

  fragment Fields on IField {
    ...NestableFieldContent
    ... on RTEField {
      key
      referencesWithKey {
        key
        reference {
          ...ReferenceContent
        }
      }
      value
    }
    ... on ObjectField {
      key
      fields {
        ...NestableFieldContent
        ... on ObjectField {
          key
          fields {
            ...NestableFieldContent
          }
        }
      }
    }
    ... on NavigationField {
      key
      navigation {
        id
        title
        link {
          id
          url
          image {
            url
          }
          references {
            ... on Page {
              id
              type
              title
            }
          }
        }
      }
    }
  }
`
